<script setup>
import { computed, onBeforeUnmount, onMounted, ref, watch } from 'vue'
import { useTranslaterStore } from '@/stores/translater'

const translaterStore = useTranslaterStore()

const props = defineProps({
    header: {
        type: String,
        required: true
    },

    fieldsRequired: {
        type: Boolean,
        required: false
    },

    size: {
        type: String,
        required: false
    },

    show: {
        type: Boolean,
        required: false,
        default: true
    }
})

const modal = ref(null)

const getTranslate = computed(() => translaterStore.getTranslate)

onMounted(() => {
    const modalWrapper = document.getElementsByClassName('modal-wrapper')[0]
    const modalBody = document.getElementsByClassName('modal-container')[0]
    const scrollbarWidth = window.innerWidth - document.body.offsetWidth

    document.body.style.overflow = props.show ? 'hidden' : ''
    document.body.style.paddingRight = props.show ? scrollbarWidth + 'px' : ''

    // Переносим модальное окно в корень body [головняк с позиционированием = disable]
    modal.value = document.getElementsByClassName('modal-mask')[0]
    document.body.appendChild(modal.value)

    // Клик вне модального окна закрывает его
    modalWrapper.addEventListener('mousedown', function (event) {
        if (!modalBody.contains(event.target)) {
            emits('closeModal', true)
        }
    })

    // Закрытие модального окна по нажатию Esc
    document.addEventListener('keyup', event => (event.code == 'Escape' ? emits('closeModal', true) : null))
})

onBeforeUnmount(() => {
    document.body.style.overflow = ''
    document.body.style.paddingRight = ''
    document.body.removeChild(modal.value)
})

watch(
    () => props.show,
    mode => {
        const scrollbarWidth = window.innerWidth - document.body.offsetWidth
        document.body.style.overflow = mode ? 'hidden' : ''
        document.body.style.paddingRight = mode ? scrollbarWidth + 'px' : ''
    }
)

const emits = defineEmits(['closeModal'])
</script>

<template>
    <div class="modal-mask">
        <div class="modal-wrapper">
            <div
                class="modal-container"
                :class="{
                    'modal-container--mdfixed': props.size && props.size == 'mdf',
                    'modal-container--lgfixed': props.size && props.size == 'lgf',
                    'modal-container--xlfixed': props.size && props.size == 'xlf'
                }"
            >
                <div class="modal-header">
                    <div class="modal-header-close material-icons" @click="emits('closeModal', true)">clear</div>
                    <slot name="header">
                        <div class="modal-header-text">
                            {{ props.header }}
                        </div>
                        <div class="modal-header-subtext d-none d-md-block" v-if="props.fieldsRequired">
                            <span class="modal-header-warning">⚹</span>
                            {{ getTranslate.FORM_REQUIRED }}
                        </div>
                    </slot>
                </div>
                <div class="modal-body">
                    <slot name="body"></slot>
                </div>
                <slot name="footer"></slot>
            </div>
        </div>
    </div>
</template>
